import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";

import EventMap from "../OSCard/OSCardEventsMap";

import { translate, getLanguage } from "../Translation/Translation";

import "./InnerModal.css";

class InnerModal extends Component {
  constructor(props) {
    super(props);
    this.handleMouseMove = this.handleMouseMove.bind(this);
  }

  handleMouseMove(event) {
    event.stopPropagation();
  }

  render() {
    const {
      clickHandler,
      startDate,
      endDate,
      title,
      lat,
      lng,
      description,
      venueName,
      link,
    } = this.props;
    return (
      <Grid className="innerModal-container">
        <Row>
          <Col
            mdOffset={4}
            md={4}
            className="innerModal"
            onMouseDown={this.handleMouseMove}
          >
            <Row className="innerModal-map">
              <button
                onClick={clickHandler}
                className="innerModal-map-close-button"
              >
                &times;
              </button>

              <EventMap
                stop={{ lat: lat, lng: lng }}
                googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyDF9MTsdQEmSiTZxeyxN_0kXFW0OMEIu-I&language=en&libraries=geometry"
                loadingElement={<div style={{ height: `200px` }} />}
                containerElement={
                  <div style={{ height: `100%`, width: `100%` }} />
                }
                mapElement={
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      marginBottom: "140px",
                    }}
                  />
                }
              />
            </Row>
            <Row className="innerModal-content">
              <Col xs={12} sm={12}>
                <div className="event-info-container">
                  <h2>{title}</h2>
                  <p>{description}</p>
                  <div className="event-specific-info-container">
                    <p className="event-specific-info">
                      <i
                        aria-hidden="true"
                        className="marker small icon custom"
                      />
                      {venueName}
                    </p>
                    <p className="event-specific-info">
                      <i
                        aria-hidden="true"
                        className="calendar small icon custom"
                      />
                      {startDate} | {endDate}
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="innerModal-bottom">
              <a
                target="_blank"
                href={link}
                className="innerModal-bottom-button"
              >
                {translate(getLanguage(), "Visit Event Site")}
              </a>
            </Row>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default InnerModal;



// WEBPACK FOOTER //
// ./src/components/InnerModal/InnerModal.js